import StaffMemberCompensationRow from './StaffMemberCompensationRow.container';

export default StaffMemberCompensationRow;
